import { ActionTypeWithProps } from '@core/interfaces/store.interface';
import { EntityMap, Update } from '@ngrx/entity/src/models';
import { createAction, props } from '@ngrx/store';

export interface IAdapterActions<T> {
	// Entities
	setAll: ActionTypeWithProps<IPropsEntities<T>>;
	addMany: ActionTypeWithProps<IPropsEntities<T>>;
	upsertMany: ActionTypeWithProps<IPropsEntities<T>>;
	updateMany: ActionTypeWithProps<IPropsUpdateEntities<T>>;
	removeMany: ActionTypeWithProps<IPropsEntityIds<T>>;

	// Entity
	setOne: ActionTypeWithProps<IPropsEntity<T>>;
	addOne: ActionTypeWithProps<IPropsEntity<T>>;
	upsertOne: ActionTypeWithProps<IPropsEntity<T>>;
	updateOne: ActionTypeWithProps<IPropsUpdateEntity<T>>;
	removeOne: ActionTypeWithProps<IPropsEntityId<T>>;

	// Others
	removeAll: ActionTypeWithProps<IBaseProps>;
	mapEntity: ActionTypeWithProps<IPropsEntityMap<T>>;
}

export interface IBaseProps { caller: string; }
export interface IPropsEntities<T> extends IBaseProps {entities: T[]; }

export interface IPropsUpdateEntities<T> extends IBaseProps {entitiesUpdateData: Update<T>[]; }

export interface IPropsEntityIds<T> extends IBaseProps {entityIds: string[]; }

export interface IPropsEntity<T> extends IBaseProps {entity: T; }

export interface IPropsUpdateEntity<T> extends IBaseProps {entityUpdateData: Update<T>; }

export interface IPropsEntityId<T> extends IBaseProps {entityId: string; }

export interface IPropsEntityMap<T> extends IBaseProps {entityMap: EntityMap<T>; }


export function adapterActions<T>(storeId: string) {
	return {
		// Entities
		addMany: createAction(`[SHARED ENTITY ACTION] ADD MANY ${ storeId }`, props<IPropsEntities<T>>()),
		setAll: createAction(`[SHARED ENTITY ACTION] SET ALL ${ storeId }`, props<IPropsEntities<T>>()),
		upsertMany: createAction(`[SHARED ENTITY ACTION] UPSERT MANY ${ storeId }`, props<IPropsEntities<T>>()),
		updateMany: createAction(`[SHARED ENTITY ACTION] UPDATE MANY ${ storeId }`, props<IPropsUpdateEntities<T>>()),
		removeMany: createAction(`[SHARED ENTITY ACTION] REMOVE MANY ${ storeId }`, props<IPropsEntityIds<T>>()),

		// Entity
		addOne: createAction(`[SHARED ENTITY ACTION] ADD ONE ${ storeId }`, props<IPropsEntity<T>>()),
		setOne: createAction(`[SHARED ENTITY ACTION] SET ONE ${ storeId }`, props<IPropsEntity<T>>()),
		upsertOne: createAction(`[SHARED ENTITY ACTION] UPSERT ONE ${ storeId }`, props<IPropsEntity<T>>()),
		updateOne: createAction(`[SHARED ENTITY ACTION] UPDATE ONE ${ storeId }`, props<IPropsUpdateEntity<T>>()),
		removeOne: createAction(`[SHARED ENTITY ACTION] REMOVE ONE ${ storeId }`, props<IPropsEntityId<T>>()),

		// Others
		removeAll: createAction(`[SHARED ENTITY ACTION] REMOVE ALL ${ storeId }`, props<IBaseProps>()),
		mapEntity: createAction(`[SHARED ENTITY ACTION] MAP ENTITY ${ storeId }`, props<IPropsEntityMap<T>>()),
	};
}
